import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const F = "'Plus Jakarta Sans',sans-serif";

export default function TermsPage({ onBack }) {
  const { isRTL } = useLanguage();

  const sections = [
    {
      title: '1. Acceptance of Terms',
      body: 'By registering or using IELTS Compass and Compass Academy ("the Service"), you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the Service.',
    },
    {
      title: '2. Service Description',
      body: 'IELTS Compass provides AI-assisted IELTS writing practice and feedback. Compass Academy connects students with qualified English language teachers for scheduled lessons via Zoom.',
    },
    {
      title: '3. Account Registration',
      body: 'You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your password. Notify us immediately of any unauthorised use of your account.',
    },
    {
      title: '4. Cancellation Policy',
      body: 'Lessons cancelled with less than 24 hours notice will be charged in full. Cancellations made 24 hours or more in advance will be rescheduled at no charge. No-shows are charged in full. In cases of emergency, please contact Mr. Ahmed Salem directly on WhatsApp.',
    },
    {
      title: '5. Subscription & Payments',
      body: 'Subscription fees are non-refundable unless otherwise agreed in writing. Hours not used within the subscription period do not carry over unless explicitly agreed. Payment is due before the subscription period begins.',
    },
    {
      title: '6. Intellectual Property',
      body: 'All content, materials, and AI feedback provided through the Service are the intellectual property of IELTS Compass. You may not reproduce, distribute, or resell any content without prior written consent.',
    },
    {
      title: '7. Limitation of Liability',
      body: 'IELTS Compass provides AI feedback as a learning tool only. We do not guarantee specific IELTS band score improvements. AI feedback is supplementary and should not replace advice from a certified IELTS examiner.',
    },
    {
      title: '8. Privacy',
      body: 'Your personal data is handled in accordance with our Privacy Policy. We collect only the information necessary to provide the Service and do not sell your data to third parties.',
    },
    {
      title: '9. Modifications',
      body: 'We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.',
    },
    {
      title: '10. Contact',
      body: 'For any questions or concerns, please contact Mr. Ahmed Salem via WhatsApp at +20 100 818 2425.',
    },
  ];

  return (
    <div dir={isRTL?'rtl':'ltr'} style={{ minHeight:'100vh', background:'#f8f9fb', fontFamily:F }}>
      {/* Header */}
      <div style={{ background:'linear-gradient(135deg,#1a2a4a,#2a3a5a)', padding:'24px 24px 20px', color:'#fff' }}>
        <div style={{ maxWidth:700, margin:'0 auto' }}>
          <button onClick={onBack}
            style={{ background:'rgba(255,255,255,0.12)', border:'1px solid rgba(255,255,255,0.2)', color:'#fff', borderRadius:8, padding:'6px 14px', fontSize:12, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.07em', marginBottom:16 }}>
            ← Back
          </button>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.2em', textTransform:'uppercase', color:'rgba(255,255,255,0.5)', marginBottom:6 }}>
            IELTS Compass
          </div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:700 }}>
            Terms &amp; Conditions
          </div>
          <div style={{ fontSize:12, color:'rgba(255,255,255,0.6)', marginTop:6 }}>
            Last updated: May 2025
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth:700, margin:'0 auto', padding:'32px 24px 60px' }}>
        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom:28 }}>
            <div style={{ fontSize:15, fontWeight:700, color:'#1a2a4a', marginBottom:8 }}>{s.title}</div>
            <div style={{ fontSize:14, color:'#4a5a78', lineHeight:1.75 }}>{s.body}</div>
          </div>
        ))}

        <div style={{ borderTop:'1px solid #e8edf5', paddingTop:24, marginTop:8 }}>
          <div style={{ fontSize:13, color:'#9aa3b8', lineHeight:1.7 }}>
            These Terms & Conditions are effective as of May 2025 and govern all use of the IELTS Compass platform and Compass Academy services.
          </div>
        </div>
      </div>
    </div>
  );
}
